// biome-ignore lint/performance/noBarrelFile: intentional
export {
  type ToSignatureErrorType as ToFunctionSignatureErrorType,
  toSignature as toFunctionSignature,
} from './toSignature.js'
